import React from 'react';
import propTypes from 'prop-types';
import Styled from 'styled-components';
import DavieLogoColor from '../Assets/davieai-logo-color.png';

const WelcomeToDavieSection = Styled.div`
margin-top: 40px;
width: 100%;
height: 48px; 
display: flex;
flex-direction: column;
align-items: center;
margin-bottom: 170px;

`;

const Welcome = Styled.div`
text-align: center;
letter-spacing: 0px;
color: #2e69fe;
opacity: 1;
font-size: 49px;
`;

const DavieLogo = Styled.img`
width: 100%;
max-width: 500px;

`;

const WelcomeToDavie = ({ showWelcome, marginBottom }) => (
    <WelcomeToDavieSection marginBottom={marginBottom}>
        {showWelcome ? <Welcome>Welcome to</Welcome> : null}
        <DavieLogo src={DavieLogoColor} />
    </WelcomeToDavieSection>
);

WelcomeToDavie.propTypes = {
    showWelcome: propTypes.bool,
    marginBottom: propTypes.string,
};

WelcomeToDavie.defaultProps = {
    showWelcome: true,
    marginBottom: '210px',
};
export default WelcomeToDavie;
